import React from 'react';
import times from 'lodash/times';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { Card } from '../CommonComponents/OPL/Card/Card';
import { HtmlTable } from '../CommonComponents/OPL/HtmlTable/HtmlTable';

const ROWS_COUNT = 10;
const COLUMNS_COUNT = 2;

export const DashboardLoading = () => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Shimmer width={300} height={48} />
        <Shimmer width={80} height={16} />
      </Box>
      <Box display="flex" mt="24" style={{ gap: 24 }}>
        {times(5).map(key => (
          <Card width="100%" key={key} p={24}>
            <Shimmer width="100%" height={16} mb={8} />
            <Shimmer width="100%" height={32} />
          </Card>
        ))}
      </Box>
      <Box display="flex" flexWrap="wrap" mt="24" style={{ gap: 40 }}>
        {times(3).map(key => (
          <HtmlTable key={key} width="48%">
            <table>
              <colgroup>
                <col width="60%" />
                <col width="40%" />
              </colgroup>
              <caption>
                <Shimmer width="50%" height={24} />
              </caption>

              <thead>
                <tr>
                  {times(COLUMNS_COUNT).map(key => (
                    <th key={key}>&nbsp;</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {times(ROWS_COUNT).map(key => (
                  <tr key={key}>
                    {times(COLUMNS_COUNT).map(cellKey => (
                      <td key={cellKey}>
                        <Shimmer width="100%" height={24} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </HtmlTable>
        ))}
      </Box>
    </>
  );
};
